import type { RouteComponentProps } from "react-router-dom";

import { createRedesignEntry } from "~/components/redesign-v1/redesign-page-entry";

export default createRedesignEntry<RouteComponentProps<{ patient_id: string }>>(() => import("./PatientReportPage"), {
  testId: "treatment-report-loading",
  shell: (props) => ({
    activeNav: "patients",
    footer: false,
    breadcrumbTrail: [{ id: "redesign.shell.patient", defaultMessage: "Patient {id}", values: { id: props.match.params.patient_id }, to: `/pages/patient/${props.match.params.patient_id}` }],
    breadcrumbLeaf: { id: "reportTitle", defaultMessage: "Treatment plan report" },
  }),
});
